import * as t from './actionTypes';

export function setToday(day) {
    return {
        type: t.EDIT_TODAY,
        payload: day
    };
}